import React from 'react';

const AttendanceSection = ({ attendance = {}, primaryColor = '#1e3a8a' }) => {
  const hasRecord = Boolean(
    attendance && (
      attendance.hasRecord ||
      (attendance.workingDays !== undefined && attendance.workingDays > 0) ||
      (attendance.presentDays !== undefined && attendance.presentDays > 0)
    )
  );

  if (!hasRecord) {
    return (
      <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '8px', padding: '10px 14px', fontSize: '11px', marginBottom: '16px' }}>
        <div style={{ fontWeight: '700', color: primaryColor, marginBottom: '2px', textTransform: 'uppercase' }}>📅 Attendance Record</div>
        <div style={{ color: '#64748b', fontStyle: 'italic' }}>
          Attendance records not yet marked in database for this student and academic session.
        </div>
      </div>
    );
  }

  const { workingDays = 0, presentDays = 0, absentDays = 0, percentage = 0 } = attendance;

  return (
    <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '10px 14px', fontSize: '11px', marginBottom: '16px' }}>
      <div style={{ fontWeight: '700', color: '#166534', marginBottom: '4px', textTransform: 'uppercase' }}>📅 Attendance Record</div>
      <div style={{ color: '#15803d', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
        <span>Total Working Days: <strong>{workingDays}</strong></span>
        <span>Days Present: <strong>{presentDays}</strong></span>
        <span>Days Absent: <strong>{absentDays}</strong></span>
        <span>Attendance: <strong>{percentage}%</strong></span>
      </div>
    </div>
  );
};

export default AttendanceSection;
